document.addEventListener("DOMContentLoaded", function () {

    const popup = document.getElementById("tm-newsletter-overlay");

    if (!popup) return;

    const closeBtn = popup.querySelector(".tm-close");
    const noThanks = popup.querySelector(".tm-no-thanks");
    const form = document.getElementById("tm-newsletter-form");

    // -----------------------------
    // Settings
    // -----------------------------

    const STORAGE_KEY = "tm_newsletter_popup_closed";

    const DELAY =
    Number(document.body.dataset.popupDelay || 5) * 1000;


    // -----------------------------
    // Already Closed?
    // -----------------------------

    if (localStorage.getItem(STORAGE_KEY)) {

        return;

    }


    // -----------------------------
    // Open Popup
    // -----------------------------

    setTimeout(function () {

        popup.classList.add("active");

        document.body.style.overflow = "hidden";

    }, DELAY);


    // -----------------------------
    // Close Function
    // -----------------------------

    function closePopup(save = true) {

        popup.classList.remove("active");

        document.body.style.overflow = "";

        if (save) {

            localStorage.setItem(STORAGE_KEY, "true");

        }

    }


    // -----------------------------
    // Close Button
    // -----------------------------

    closeBtn.addEventListener("click", function () {

        closePopup();

    });


    // -----------------------------
    // No Thanks
    // -----------------------------

    if (noThanks) {

        noThanks.addEventListener("click", function () {

            closePopup();

        });

    }


    // -----------------------------
    // Overlay Click
    // -----------------------------

    popup.addEventListener("click", function (e) {

        if (e.target === popup) {

            closePopup();

        }

    });


    // -----------------------------
    // ESC Key
    // -----------------------------

    document.addEventListener("keydown", function (e) {

        if (e.key === "Escape") {

            closePopup();

        }

    });


    // -----------------------------
    // Form Validation
    // -----------------------------

    if (form) {

        form.addEventListener("submit", function (e) {

            const name =
                form.querySelector('input[name="contact[first_name]"]');

            const email =
                form.querySelector('input[name="contact[email]"]');

            const phone =
                form.querySelector('input[name="contact[note][phone]"]');

            if (name.value.trim() === "") {

                alert("Please enter your full name.");

                e.preventDefault();

                return;

            }

            if (email.value.trim() === "") {

                alert("Please enter your email.");

                e.preventDefault();

                return;

            }

            if (phone.value.trim() === "") {

                alert("Please enter your phone number.");

                e.preventDefault();

                return;

            }

            closePopup();

        });

    }

});